import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Grid, Typography, Paper } from '@mui/material';
import { useAuth } from '../hooks/useAuth';
import logo from '../assets/images/cards/Chinmaya-Mission-Logo.gif';

export default function EventTxnsHistory() {

    const { accessToken, signOut } = useAuth();
    const API_URL = process.env.REACT_APP_API_URL;
    const [eventTxnsHistory, setEventTxnsHistory] = useState();
    
    //console.log("Entry EventTxnsHistory form :", accessToken);

    
    useEffect(() => {
        console.log("EventTxnsHistory form - useeffect[]  :", accessToken);
        if (accessToken) {
          eventTxnsHistoryFetch();
        }
      }, [accessToken]);
    
      const eventTxnsHistoryFetch = async () => {
      let response, data;
      try {    
        const response = await fetch(`${API_URL}/gquery`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-cmdfw-jwt-token': `${accessToken}`,
          },
            body: JSON.stringify({
                query: `
                        query {
                          eventsHistory {
                              events {
                                  memEventsId
                                  status
                                  startDate
                                  endDate
                                  memberEntity {
                                      memberId
                                      memberType
                                      fullName
                                  }
                                  eventTypesEntity {
                                      eventTypeId
                                      name
                                      eventYear
                                      price
                                  }
                                  transactionEntity {
                                      transactionId
                                      quantities
                                      totalAmount
                                      paymentStatus
                                      createdAt
                                  }
                              }
                            }
                        }
                      `,
          }),
        });
  
        const data = await response.json();
        if (response.ok) {
          console.log("Event history data API call:", response, data.data.eventsHistory.events);

          setEventTxnsHistory(data.data.eventsHistory.events);
        } else {
          if (response.status === 403) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'OTP expired');
            //handleLogout(); // Logout user
          } else {
            if (!response.ok) {
              const errorData = await response.json();
              throw new Error(errorData.message || 'Membership fetch failed');
            }
          }
        }
      } catch (error) {
        console.error("Error fetching Event Txns History :", error);
        //signOut();
        //navigate('/');
      }
    };
    
    function createData(name, calories, fat, carbs, protein) {
        return { name, calories, fat, carbs, protein };
      }

  return (
    
    <Grid container alignItems="center" >
        <Paper elevation={3}>
            <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
            <Typography variant="h7" align="left" gutterBottom>
                <b>Event Transactions History</b>
            </Typography>
            </Paper>
            <div><br /></div>
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 250 }} aria-label="simple table">
        <TableHead>
          <TableRow style={{ backgroundColor: '#1976d2', color: 'white' }}>
            <TableCell align="left" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Event Name</TableCell>
            <TableCell align="left" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }} >Event Year</TableCell>
            <TableCell align="left" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Status</TableCell>
            <TableCell align="left" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Member Name</TableCell>
            <TableCell align="left" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>quantities</TableCell>
            <TableCell align="left" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Transaction Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {eventTxnsHistory && eventTxnsHistory.map((row) => (
            <TableRow
              key={row.transactionId}
            >
              <TableCell align="left">{row.eventTypesEntity.name}</TableCell>
              <TableCell align="left">{row.eventTypesEntity.eventYear}</TableCell>
              <TableCell align="left">{row.status}</TableCell>
              <TableCell align="left">{row.memberEntity.fullName}</TableCell>
              <TableCell align="left">{row.transactionEntity.quantities}</TableCell>
              <TableCell align="left">{row.transactionEntity.createdAt}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </Paper>
    </Grid>
  );
}
